
import React from 'react'
import {
  Link
} from 'react-router-dom'
import InputRow from './InputRow'
import PropTypes from 'prop-types'

import submit from '../submit.gif'


export class FormPage extends React.Component {
  ''
  constructor(props) {
    super(props)
    this.state = {
      processing: false,
      resetProcessing: false,
      loading: true,
      saved: false,
      error: '',
      People_Id: '',
      Event_ID: '',
      Event_Sub_Type: '',
      Section: '',
      course: '',
      isEnglish: '',
      campus: '',
      major: '',
      lms: [{ "Id": "Moodle", "value": "Moodle" }, { "Id": "Google Classroom", "value": "Google Classroom" }, { "Id": "Blackboard", "value": "Blackboard" }, { "Id": "None", "value": "None" }, { "Id": "Other", "value": "Other" }],
      selectedlms: [],
      conferencePlat: [{ "Id": "Google Meet", "value": "Google Meet" }, { "Id": "Zoom", "value": "Zoom" }, { "Id": "Microsoft Teams", "value": "Microsoft Teams" }, { "Id": "None", "value": "None" },
      { "Id": "Other", "value": "Other" }],
      selectedConferencePlat: [],
      socialMedia: [{ "Id": "Whatsapp", "value": "Whatsapp" }, { "Id": "Facebook", "value": "Facebook" }, { "Id": "Instagram", "value": "Instagram" }, { "Id": "Twitter", "value": "Twitter" }
        , { "Id": "Telegram", "value": "Telegram" }, { "Id": "Signal", "value": "Signal" }, { "Id": "None", "value": "None" }, { "Id": "Other", "value": "Other" }],
      selectedsocialMedia: [],
      otherSocialMedia: '', otherConference: '', otherLMS: '',
      grades: [{ "Id": "A", "value": "A" }, { "Id": "B", "value": "B" }, { "Id": "C", "value": "C" }, { "Id": "D", "value": "D" }, { "Id": "F", "value": "F" }, { "Id": "Withdraw", "value": "Withdraw" }],
      selectedExpectedGrade: '',
      GPA: [{ "Id": "4.0", "value": "4.0" }, { "Id": "3.5 - 3.9", "value": "3.5 - 3.9" }, { "Id": "3.1 - 3.4", "value": "3.1 - 3.4" }, { "Id": "3.0", "value": "3.0" }, { "Id": "2.5 - 2.9", "value": "2.5 - 2.9" }, { "Id": "2.1 - 2.4", "value": "2.1 - 2.4" }
        , { "Id": "2.0", "value": "2.0" }, { "Id": "below 2.0", "value": "below 2.0" }, { "Id": "This is my First Semester in College.", "value": "This is my First Semester in College." }],
      selectedGPA: '',
      optionsList: [{ "Id": 1, "value": "1" }, { "Id": 2, "value": "2" }, { "Id": 3, "value": "3" }, { "Id": 4, "value": "4" }, { "Id": 5, "value": "5" }],
      selectedOptionsList: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
      questionsList:
        [{ "Id": "1.1", "value": "1.1. In this course, I learned a lot of information, concepts, principles, and theories of the subject matter." },
        { "Id": "1.2", "value": "1.2.  In this course, I was fully exposed to the current issues and trends in the field." },
        { "Id": "1.3", "value": "1.3. In this course, I learned to solve typical market-related  problems in the field." },
        { "Id": "1.4", "value": "1.4. In this course, I improved my critical thinking and decision-making skills very well." },
        { "Id": "1.5", "value": "1.5. In this course, I learned to be a more creative and adaptive thinker." },
        { "Id": "1.6", "value": "1.6. In this course, I saw how other fields (other than my major) can help address challenges specific to my field of study." },
        { "Id": "1.7", "value": "1.7. In this course, I learned a lot about my personal preferences, areas of strength and challenges." },
        { "Id": "1.8", "value": "1.8. In this course, I learned how to deal with others and be an effective team player." },
        { "Id": "1.9", "value": "1.9. In this course, I learned how to behave professionally and ethically in the future." },
        { "Id": "1.10", "value": "1.10. In this course, I learned to promote social values more than I used to. (e.g. Social justice, Integrity, Tolerance, Honesty)." },
        { "Id": "1.11", "value": "1.11. In this course, I learned how to be an independent learner." },
        { "Id": "1.12", "value": "1.12. Generally speaking, I am extremely satisfied with what I have learned in this course?" },
        { "Id": "2.1", "value": "2.1. The instructor clearly set and explained the rules of face-to-face classroom, online engagement and netiquette and or provided me with basic guidance in the use of technology as needed." },
        { "Id": "2.2", "value": "2.2. The Instructor was always in class on time (whether in-person or online)." },
        { "Id": "2.3", "value": "2.3. I was able to have an appointment with the instructor for a one-on-one meeting (whether online or in-person- Like office hours)" },
        { "Id": "2.4", "value": "2.4. The instructor was very supportive, warm, and respectful to all students." },
        { "Id": "2.5", "value": "2.5. The instructor was generally organized and well prepared" },
        { "Id": "2.6", "value": "2.6.  Generally speaking, I am extremely satisfied with the instructor's online presence and course management?" },
        { "Id": "3.1", "value": "3.1. The instructor gave us reasonable pre-class reading (or viewing) assignments at the beginning of new units, or course modules." },
        { "Id": "3.2", "value": "3.2. The instructor gave us small comprehension test to check our initial understanding of the pre-class reading assignment at the beginning of a class session, when the reading assignment was due." },
        { "Id": "3.3", "value": "3.3. After checking our initial understanding of the pre-class reading, the instructor taught us ONLY what was not understood by uspage on our own." },
        { "Id": "3.4", "value": "3.4. Generally speaking, the instructor lectured and explained less during class time and instead gave us a chance to discuss course concepts, solve problems, analyze and do critical thinking, and other application tasks." },
        { "Id": "3.5", "value": "3.5. During class time, the instructor occasionally  gave us small assessment tasks where we had to think on our own (individually or in teams), after which he gave us immediate feedback and sometimes graded us." },
        { "Id": "3.6", "value": "3.6. The instructor provided us with a criteria of evaluation (scoring sheet called a RUBRIC) for our major assignments and projects." },
        { "Id": "3.7", "value": "3.7. The instructor graded and returned our online-assignments/work and tests in a timely fashion." },
        { "Id": "3.8", "value": "3.8. The instructor occasionally gave us a chance to reflect on WHAT and HOW we are learning." },
        { "Id": "3.9", "value": "3.9. The instructor occasionally  asked us to evaluate our work on our own using a clear criteria of evaluation (Self-Assessment)." },
        { "Id": "3.10", "value": "3.10. The instructor's grading was fair and consistent with the stated course learning outcomes (objectives)." },
        { "Id": "3.11", "value": "3.11. The instructor gave us an end-of-class culminating project (Capstone), and this project was a great experience that allowed us to see the whole purpose of the course." },
        { "Id": "3.12", "value": "3.12. In this course, we engaged in team tasks during class time and under the supervision of our instructor. (Using Zoom, or other, breakout rooms)" },
        { "Id": "3.13", "value": "3.13. The instructor always spoke English in class, and expected us to do the same." },
        { "Id": "3.14", "value": "3.14. The instructor demonstrated a strong knowledge of the subject matter." },
        { "Id": "4.1", "value": "4.1 I would recommend this course to other students." },
        { "Id": "4.2", "value": "4.2 I would recommend this instructor to other students." }],
      questionsNumbers: ["1.1", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "1.10", "1.11", "1.12", "2.1", "2.2", "2.3", "2.4", "2.5", "2.6", "3.1", "3.2", "3.3", "3.4", "3.5", "3.6", "3.7", "3.8", "3.9", "3.10", "3.11", "3.12", "3.13", "3.14", "4.1", "4.2"],
      selectedDoneEspecially: '',
      selectedSpecificSuggestion: '',
      errordisplayLMS: false,
      errordisplayConferencePlat: false,
      errordisplaysocialMedia: false,
      errordisplayExpectedGrade: false,
      errordisplayGPA: false,
      SpecificSuggestion: false,
      errorDoneEspecially: false,
      errorSpecificSuggestion: false,
      isSuccessfull:false,
      errorOptionsList: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      activeSections: [false, false, false, false, false]
    }

    this.handleSubmit = this.handleSubmit.bind(this)

  }

  componentDidMount() {

    let People_IdParam = '';
    let Event_IdParam = '';
    let Event_Sub_TypeParam = '';
    let SectionParam = '';
    this.toggleAccordion(0)
    People_IdParam = new URLSearchParams(window.location.search).get('peopleid');
    Event_IdParam = new URLSearchParams(window.location.search).get('eventid');
    Event_Sub_TypeParam = new URLSearchParams(window.location.search).get('eventsubtype');
    SectionParam = new URLSearchParams(window.location.search).get('section');
    this.setState({ People_Id: People_IdParam, Event_ID: Event_IdParam, Event_Sub_Type: Event_Sub_TypeParam, Section: SectionParam })
    const {

      selectedlms,
      selectedConferencePlat,
      selectedsocialMedia,
      otherSocialMedia,
      otherLMS,
      otherConference,
      selectedExpectedGrade,
      selectedGPA,
      selectedDoneEspecially,
      selectedSpecificSuggestion,
      selectedOptionsList,
      questionsNumbers
    } = this.state
    fetch(`${process.env.REACT_APP_API_URL}/api/submit/validateInput`, {
      method: 'POST',
      body: JSON.stringify({
        questionsNumbers: questionsNumbers,
        People_Id: People_IdParam,
        Event_ID: Event_IdParam,
        Section: SectionParam,
        Event_Sub_Type: Event_Sub_TypeParam,
        selectedlms: selectedlms,
        selectedConferencePlat: selectedConferencePlat,
        selectedsocialMedia: selectedsocialMedia,
        otherSocialMedia: otherSocialMedia,
        otherConference: otherConference,
        otherLMS: otherLMS,
        selectedExpectedGrade: selectedExpectedGrade,
        selectedGPA: selectedGPA,
        selectedDoneEspecially: selectedDoneEspecially,
        selectedSpecificSuggestion: selectedSpecificSuggestion,
        selectedOptionsList: selectedOptionsList,

      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(res => {

        if (res.StatusCode === 200) {

          this.setState({ course: res.Data.Event, campus: res.Data.Campus, major: res.Data.Degree, People_Id: res.Data.People_Id, Event_ID: res.Data.Event_ID, Event_Sub_Type: res.Data.Event_Sub_Type, Section: res.Data.Section, processing: false, loading: false, isEnglish: res.Data.IsEnglish })

          //window.location.replace('./' + res.Data.redirect_url);
        } else {
          this.setState({ error: res.Msg, loading: false, errorColor: 'red', governmentId: '' })
        }
      })
      .catch((err) => {
        this.setState({ error: 'Network Error', processing: false, loading: false })
        console.log(err)
      })
  }



  toggleAccordion(index) {
    const { activeSections } = this.state
    const sectionsBody = []
    activeSections.forEach((section, i) => {
      if (i === index) {
        section = !section
      } else {
        section = false
      }
      sectionsBody.push(section)
    })
    this.setState({ activeSections: sectionsBody })
  }


  toggleAll() {
    const { activeSections } = this.state
    const sectionsBody = []
    activeSections.forEach((section, i) => {
      section = false
      sectionsBody.push(section)
    })
    this.setState({ activeSections: sectionsBody })
  }

  async handleSubmit() {

    const {

      selectedlms,
      selectedConferencePlat,
      selectedsocialMedia,
      otherSocialMedia,
      selectedExpectedGrade,
      selectedGPA,
      selectedDoneEspecially,
      selectedSpecificSuggestion,
      selectedOptionsList,
      People_Id,
      Event_ID,
      Event_Sub_Type,
      Section,
      questionsNumbers,
      IsEnglish,
      otherConference,
      otherLMS
    } = this.state
    let toSubmit = true

    this.setState({processing:true})

    this.toggleAll()
    const errorList = [false, false, false, false];


    if (selectedlms.length <= 0) {
      this.setState({ errordisplayLMS: true })
      errorList[0] = true
      toSubmit = false
    } else {
      if (selectedlms.includes("Other") && (otherLMS === '' || otherLMS === ' ')) {
        errorList[0] = true
        this.setState({ errordisplayLMS: true })
        toSubmit = false
      } else
        this.setState({ errordisplayLMS: false })
    }

    if (selectedConferencePlat.length <= 0) {
      errorList[0] = true
      this.setState({ errordisplayConferencePlat: true })
      toSubmit = false
    } else {
      if (selectedConferencePlat.includes("Other") && (otherConference === '' || otherConference === ' ')) {
        errorList[0] = true
        this.setState({ errordisplayConferencePlat: true })
        toSubmit = false
      } else
        this.setState({ errordisplayConferencePlat: false })


    }


    if (selectedsocialMedia.length <= 0) {
      errorList[0] = true
      this.setState({ errordisplaysocialMedia: true })
      toSubmit = false
    } else {
      if (selectedsocialMedia.includes("Other") && (otherSocialMedia === '' || otherSocialMedia === ' ')) {
        errorList[0] = true
        this.setState({ errordisplaysocialMedia: true })
        toSubmit = false
      } else
        this.setState({ errordisplaysocialMedia: false })
    }
    if (otherSocialMedia === '') {

    }
    if (selectedExpectedGrade === '') {
      errorList[0] = true
      this.setState({ errordisplayExpectedGrade: true })
      toSubmit = false
    } else {
      this.setState({ errordisplayExpectedGrade: false })
    }
    if (selectedGPA === '') {
      errorList[0] = true
      this.setState({ errordisplayGPA: true })
      toSubmit = false
    } else {
      this.setState({ errordisplayGPA: false })
    }
    if (selectedDoneEspecially === '') {
      this.setState({ errorDoneEspecially: true })
      toSubmit = false
      errorList[4] = true
    } else {
      this.setState({ errorDoneEspecially: false })
    }
    if (selectedSpecificSuggestion === '') {
      this.setState({ errorSpecificSuggestion: true })
      toSubmit = false
      errorList[4] = true
    } else {
      this.setState({ errorSpecificSuggestion: false })
    }
    let errorOptionsList = [...this.state.errorOptionsList];
    let questionsList = [...this.state.questionsList];
    selectedOptionsList.forEach((element, index) => {
      if (element == '0') {
        toSubmit = false

        let item = { ...errorOptionsList[index] };
        item = true;
        errorOptionsList[index] = item;
        if (questionsList[index].Id.includes("1.")) {
          errorList[1] = true
        } else if (questionsList[index].Id.includes("2.")) {
          errorList[2] = true
        } else if (questionsList[index].Id.includes("3.")) {
          errorList[3] = true
        } else if (questionsList[index].Id.includes("4.")) {
          errorList[4] = true
        }
      }
      else {
        let item = { ...errorOptionsList[index] };
        item = false;
        errorOptionsList[index] = item;

      }
    });
    this.setState({ errorOptionsList })
    if (errorList[0] == true) {
      this.toggleAccordion(0)
    } else if (errorList[1] == true) {
      this.toggleAccordion(1)
    }
    else if (errorList[2] == true) {
      this.toggleAccordion(2)
    }
    else if (errorList[3] == true) {
      this.toggleAccordion(3)
    }
    else if (errorList[4] == true) {
      this.toggleAccordion(4)
    }

    if(toSubmit==false)
    {
      this.setState({ processing: false })
    }

    if (toSubmit == true) {
      fetch(`${process.env.REACT_APP_API_URL}/api/submit/submit`, {
        method: 'POST',
        body: JSON.stringify({
          questionsNumbers: questionsNumbers,
          People_Id: People_Id,
          Event_ID: Event_ID,
          Event_Sub_Type: Event_Sub_Type,
          Section: Section,
          selectedlms: selectedlms,
          selectedConferencePlat: selectedConferencePlat,
          selectedsocialMedia: selectedsocialMedia,
          otherSocialMedia: otherSocialMedia,
          otherLMS: otherLMS,
          otherConference: otherConference,
          selectedExpectedGrade: selectedExpectedGrade,
          selectedGPA: selectedGPA,
          selectedDoneEspecially: selectedDoneEspecially,
          selectedSpecificSuggestion: selectedSpecificSuggestion,
          selectedOptionsList: selectedOptionsList,

        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => res.json())
        .then(res => {

          if (res.StatusCode === 200) {

            this.setState({ processing: false })
            this.setState({ error: "Thank you for submitting the survey, your evaluation has been successfully submitted. To return to the surveys page, please click on the following link "})
            this.setState({isSuccessfull:true})
            //window.location.replace('./' + res.Data.redirect_url);
          } else {
            //this.setState({ error: res.Msg, processing: false, errorColor: 'red', governmentId: '' })
            this.setState({ error: 'Something went wrong while submitting the form.', processing: false, governmentId: '' })
          }
        })
        .catch((err) => {
          this.setState({ error: 'Something went wrong while submitting the form.', processing: false, governmentId: '' })

        })

    }


  }



  render() {
    const {
      processing,
      resetProcessing,
      loading,
      lms,
      selectedlms,
      conferencePlat,
      selectedConferencePlat,
      socialMedia,
      selectedsocialMedia,
      otherSocialMedia,
      otherConference,
      otherLMS,
      grades,
      selectedExpectedGrade,
      GPA,
      selectedGPA,
      optionsList,
      selectedOptionsList,
      questionsList,
      saved,
      selectedDoneEspecially,
      selectedSpecificSuggestion,
      errordisplayLMS,
      errordisplayConferencePlat,
      errordisplaysocialMedia,
      errordisplayExpectedGrade,
      errordisplayGPA,
      errorDoneEspecially,
      errorSpecificSuggestion,
      errorOptionsList,
      error,
      activeSections,
      course,
      campus,
      major,
      isEnglish,
      isSuccessfull
    } = this.state




    let displayLMS = []

    lms.forEach((element, index) => {

      displayLMS.push(
        <label key={element.Id}>
          <input
            type="checkbox"
            value={element.Id}
            name="lms"

            checked={selectedlms.indexOf(element.Id) !== -1}
            onChange={(e) => {

              if (selectedlms.indexOf(e.target.value) === -1) {

                //this.setState({ selectedlms: [...this.state.selectedlms, e.target.value] })


                const value = e.target.value;
                const selected = [...this.state.selectedlms];

                if (value === "None" || value === "Other") {
                  // If "none" is selected, deselect all other options
                  this.setState({ selectedlms: [value] });

                } else if (selected.indexOf("None") !== -1 || selected.indexOf("Other") !== -1) {
                  // If "none" was previously selected, don't allow selecting other options

                  this.setState({ selectedlms: [value] });
                } else if (selected.indexOf(value) === -1) {
                  // If a non-"none" option is selected, add it to the list
                  this.setState({ selectedlms: [...this.state.selectedlms, e.target.value] })
                }


              } else {
                const newSources = []
                selectedlms.forEach(element => {
                  if (element !== e.target.value) {
                    newSources.push(element)
                  }
                })
                this.setState({ selectedlms: newSources })

              }
              console.log(this.state.selectedlms)
            }}
          />
          {element.value}
        </label>
      )







    })




    let displayConferencePlat = []

    conferencePlat.forEach((element, index) => {
      displayConferencePlat.push(
        <label key={element.Id}>
          <input
            type="checkbox"
            value={element.Id}
            name="conferencePlat"

            checked={selectedConferencePlat.indexOf(element.Id) !== -1}
            onChange={(e) => {
              if (selectedConferencePlat.indexOf((e.target.value)) === -1) {


                const value = e.target.value;
                const selected = [...this.state.selectedConferencePlat];

                if (value === "None" || value === "Other") {
                  // If "none" is selected, deselect all other options
                  this.setState({ selectedConferencePlat: [value] });
                } else if (selected.indexOf("None") !== -1 || selected.indexOf("Other") !== -1) {
                  // If "none" was previously selected, don't allow selecting other options
                  this.setState({ selectedConferencePlat: [value] });
                } else if (selected.indexOf(value) === -1) {
                  // If a non-"none" option is selected, add it to the list
                  this.setState({ selectedConferencePlat: [...this.state.selectedConferencePlat, e.target.value] })
                }
              } else {
                const newSources = []
                selectedConferencePlat.forEach(element => {
                  if (element !== e.target.value) {
                    newSources.push(element)
                  }
                })
                this.setState({ selectedConferencePlat: newSources })

              }
            }}
          />
          {element.value}
        </label>
      )

    })





    let displaysocialMedia = []

    socialMedia.forEach((element, index) => {

      displaysocialMedia.push(
        <label key={element.Id}>
          <input
            type="checkbox"
            value={element.Id}
            name="socialMedia"

            checked={selectedsocialMedia.indexOf(element.Id) !== -1}
            onChange={(e) => {
              if (selectedsocialMedia.indexOf(e.target.value) === -1) {


                const value = e.target.value;
                const selected = [...this.state.selectedsocialMedia];

                if (value === "None" || value === "Other") {
                  // If "none" is selected, deselect all other options
                  this.setState({ selectedsocialMedia: [value] });
                } else if (selected.indexOf("None") !== -1 || selected.indexOf("Other") !== -1) {
                  // If "none" was previously selected, don't allow selecting other options
                  this.setState({ selectedsocialMedia: [value] });
                } else if (selected.indexOf(value) === -1) {
                  // If a non-"none" option is selected, add it to the list
                  this.setState({ selectedsocialMedia: [...this.state.selectedsocialMedia, e.target.value] })
                }


              } else {
                const newSources = []
                selectedsocialMedia.forEach(element => {
                  if (element !== e.target.value) {
                    newSources.push(element)
                  }
                })
                this.setState({ selectedsocialMedia: newSources })

              }
            }}
          />
          {element.value}
        </label>
      )


    })


    let displayGPA = []

    GPA.forEach((element, index) => {

      displayGPA.push(
        <label key={element.Id} className="radio-label">
          <input
            type="radio"
            value={element.Id}
            style={{ minWidth: 'auto', marginLeft: 5 }}
            name="GPA"

            onChange={(e) => {
              if (selectedGPA === -1) {
                this.setState({ selectedGPA: e.target.value })
              } else {
                this.setState({ selectedGPA: e.target.value })
              }
            }}
          />
          {element.value}
        </label>
      )
    })







    let displayOtherQuestionsList = []



    let displayOtherQuestions = []
    let displayOtherQuestionsWithAccordian = []
    questionsList.forEach((elements, indexes) => {
      displayOtherQuestions = []
      optionsList.forEach((element, index) => {

        displayOtherQuestions.push(

          <label key={element.Id} className="radio-label">
            <input
              type="radio"
              value={element.Id}
              style={{ minWidth: 'auto', marginLeft: 5 }}
              name={elements.Id}

              onChange={(e) => {

                let selectedOptionsList = [...this.state.selectedOptionsList];
                let item = { ...selectedOptionsList[indexes] };
                item = e.target.value;
                selectedOptionsList[indexes] = item;
                this.setState({ selectedOptionsList });

              }}
            />
            {element.value}
          </label>

        )
      })



      displayOtherQuestionsList.push(

        <div>
          <span className={'formQuestion'} key={elements.Id}>{elements.value}</span><span style={{ color: 'red' }}> *</span>
          {errorOptionsList[indexes] ? <p name={'error' + elements.Id}
            style={{
              color: 'red'
            }}>
            You must fill this field to submit this form

          </p> : null}
          <br></br>
          <div>
            {displayOtherQuestions}
            <br />
            <br />
          </div>

        </div>
      )

    })
    //displayOtherQuestionsWithAccordian1

    let displayOtherQuestionsWithAccordian1 = []
    let displayOtherQuestionsWithAccordian2 = []
    let displayOtherQuestionsWithAccordian3 = []
    let displayOtherQuestionsWithAccordian4 = []

    displayOtherQuestionsList.forEach((elements, indexes) => {
      if (elements["props"]["children"][0].key.includes("1.")) {
        displayOtherQuestionsWithAccordian1.push(
          <div>
            {elements}
          </div>
        )
      }

    })
    displayOtherQuestionsList.forEach((elements, indexes) => {
      if (elements["props"]["children"][0].key.includes("2.")) {
        displayOtherQuestionsWithAccordian2.push(
          <div>
            {elements}
          </div>
        )
      }

    })

    displayOtherQuestionsList.forEach((elements, indexes) => {
      if (elements["props"]["children"][0].key.includes("3.")) {
        displayOtherQuestionsWithAccordian3.push(
          <div>
            {elements}
          </div>
        )
      }

    })

    displayOtherQuestionsList.forEach((elements, indexes) => {
      if (elements["props"]["children"][0].key.includes("4.")) {
        displayOtherQuestionsWithAccordian4.push(
          <div>
            {elements}
          </div>
        )
      }

    })

    displayOtherQuestionsWithAccordian.push(
      <div>
        <div className={'accordion ' + (activeSections[1] ? 'open' : '')}>
          <div className="accordionSectionHeader" onClick={() => this.toggleAccordion(1)}><span className="accordionSectionHeaderContent">1</span><span className="acc-heading">COURSE LEARNING OUTCOMES (THE IMPACT)</span></div>
          <div className="accordion-form">
            <div className="accordionSectionBody">
              <span style={{ color: '#026BC8' }} >Please rate the degree to which you agree or disagree with every statement pertaining to the course on a scale of 1 to 5 <br /> (1= Strongly Disagree; 2= Disagree; 3= Neutral; 4= Agree; 5= Strongly Agree)<br />* Indicates required question</span>
              {displayOtherQuestionsWithAccordian1}
            </div>
          </div>
        </div>

        <div className={'accordion ' + (activeSections[2] ? 'open' : '')}>
          <div className="accordionSectionHeader" onClick={() => this.toggleAccordion(2)}><span className="accordionSectionHeaderContent">2</span><span className="acc-heading">INSTRUCTOR'S PRESENCE & COURSE MANAGEMENT</span></div>
          <div className="accordion-form">
            <div className="accordionSectionBody">
              <span style={{ color: '#026BC8' }} >Please rate the degree to which you agree or disagree with every statement pertaining to the course on a scale of 1 to 5 <br /> (1= Strongly Disagree; 2= Disagree; 3= Neutral; 4= Agree; 5= Strongly Agree)<br />* Indicates required question</span>

              {displayOtherQuestionsWithAccordian2}
            </div>
          </div>
        </div>
        <div className={'accordion ' + (activeSections[3] ? 'open' : '')}>
          <div className="accordionSectionHeader" onClick={() => this.toggleAccordion(3)}><span className="accordionSectionHeaderContent">3</span><span className="acc-heading">INSTRUCTOR'S TEACHING & ASSESSMENT ACTIVITIES</span></div>
          <div className="accordion-form">
            <div className="accordionSectionBody">
              <span style={{ color: '#026BC8' }} >Please rate the degree to which you agree or disagree with every statement pertaining to the course on a scale of 1 to 5 <br /> (1= Strongly Disagree; 2= Disagree; 3= Neutral; 4= Agree; 5= Strongly Agree)<br />* Indicates required question</span>

              {displayOtherQuestionsWithAccordian3}
            </div>
          </div>
        </div>
        <div className={'accordion ' + (activeSections[4] ? 'open' : '')}>
          <div className="accordionSectionHeader" onClick={() => this.toggleAccordion(4)}><span className="accordionSectionHeaderContent">4</span><span className="acc-heading">GENERAL EVALUATION</span></div>
          <div className="accordion-form">
            <div className="accordionSectionBody">
              <span style={{ color: '#026BC8' }} >Please rate the degree to which you agree or disagree with every statement pertaining to the course on a scale of 1 to 5 <br /> (1= Strongly Disagree; 2= Disagree; 3= Neutral; 4= Agree; 5= Strongly Agree)<br />* Indicates required question</span>

              {displayOtherQuestionsWithAccordian4}
              <span className={'formQuestion'} >4.3.  What has this faculty member done especially well? Please elaborate. </span><span style={{ color: 'red' }}> *</span>
              {errorDoneEspecially ? <p name={'errorDoneEspecially'}
                style={{
                  color: 'red'
                }}>
                You must fill this field to submit this form

              </p> : null}
              <InputRow
                name="4.3"
                rowName="Your answer"
                value={selectedDoneEspecially}
                required='*'
                //errMsg={validationError.selectedSecondLevel ? validationError.selectedSecondLevel : ''}
                disabled={false}
                onChange={(e) => {
                  this.setState({ selectedDoneEspecially: e })
                }}
              /><br />
              <span className={'formQuestion'} >4.4.  What specific suggestions do you have for the instructor to improve this course? Pleae elaborate.  </span><span style={{ color: 'red' }}> *</span>
              {errorSpecificSuggestion ? <p name={'errorSpecificSuggestion'}
                style={{
                  color: 'red',
                  display: 'block'
                }}>
                You must fill this field to submit this form

              </p> : null}
              <InputRow
                name="4.4"
                rowName="Your answer"
                value={selectedSpecificSuggestion}
                required='*'
                
                //errMsg={validationError.selectedSecondLevel ? validationError.selectedSecondLevel : ''}
                disabled={false} //16 is the Id of "Other" value
                onChange={(e) => {
                  this.setState({ selectedSpecificSuggestion: e })
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )







    return (
      <div>
        {loading ? null :
          <div>
            {error != '' ?
              <div id="mainContainer">
                <div id="designBorder"></div>

                <div id="main-page" >
                  <div className="sources-section">
                    <label>  {error}</label>
                    {isSuccessfull==true?
                     <a href='http://sisweb.aut.edu/PowerCampusSelfService/Registration/Schedule'>Surveys</a>:''}
                    
                  </div>
                </div>
              </div>
              :
              <div>
                {saved
                  ? <div className="alert-box">
                    <div className="alert-box-header">
                      <p>Application Saved</p>
                      <p onClick={() => this.setState({ saved: false })} style={{ cursor: 'pointer' }}>X</p>
                    </div>
                    <div className="alert-box-body">
                      <p>Your application has been saved</p>
                    </div>
                    <div className="alert-box-footer">
                      <button className="save" onClick={() => {
                        this.setState({ saved: false })
                      }}>Ok</button>
                    </div>
                  </div>
                  : null}
                <div id={saved ? 'mainContainer-blur' : 'mainContainer'}>

                  <div id="designBorder">
                    <div className='headerHidden'>
                      <div id="main-page" >
                        <div className="sources-section">
                          <label style={{ fontSize: '20px' }}>  {course}</label>
                        </div>
                      </div>
                    </div>

                    <div className='header'>
                      <div id="main-page" >
                        <div className="sources-section">
                          <label style={{ fontSize: '20px' }}>  {course}</label>
                        </div>
                      </div>
                    </div>

                    <div id="main-page" >
                      <div className="sources-section">
                        <div>
                          <div className={'accordion ' + (activeSections[0] ? 'open' : '')}>
                            <div className="accordionSectionHeader" onClick={() => this.toggleAccordion(0)}><span className="accordionSectionHeaderContent">0</span><span className="acc-heading">Basic Data Entries</span></div>
                            <div className="accordion-form">
                              <div className="accordionSectionBody">
                                <span style={{ color: '#026BC8' }} >* Indicates required question<br /></span>
                                <span className={'formQuestion'} >1.Your Course </span><span style={{ color: 'red' }}> *</span>
                                <div>
                                  {course}
                                </div>
                                <br />
                                <span className={'formQuestion'} >2. Your Campus </span><span style={{ color: 'red' }}> *</span>

                                <div>
                                  {campus}
                                </div>
                                <br />
                                <span className={'formQuestion'} >3. Your Major </span><span style={{ color: 'red' }}> *</span>

                                <div>
                                  {major}
                                </div>
                                <br />
                                <span className={'formQuestion'} >4. What Learning Management System is your instructor using? (you can choose more than one) </span><span style={{ color: 'red' }}> *</span>
                                {errordisplayLMS ? <p name={'errordisplayLMS'}
                                  style={{
                                    color: 'red'
                                  }}>
                                  You must fill this field to submit this form

                                </p> : null}
                                <div>
                                  {displayLMS}
                                </div>
                                <span style={{ color: '#026BC8' }}> If others, please specify</span>  <span style={{ color: 'red' }}> {selectedlms.includes('Other') ? '*' : ''} </span>
                                <InputRow
                                  name="text"
                                  rowName=""
                                  value={otherLMS}
                                  required={selectedlms.includes('Other') ? '' : ''}
                                  //errMsg={validationError.selectedSecondLevel ? validationError.selectedSecondLevel : ''}
                                  disabled={selectedlms.includes('Other') ? false : true} //16 is the Id of "Other" value
                                  onChange={(e) => {
                                    this.setState({ otherLMS: e })
                                  }}
                                />
                                <br />
                                <span className={'formQuestion'} >5. What Video Conferencing Platform is your instructor using? (you can choose more than one) </span><span style={{ color: 'red' }}> *</span>
                                {errordisplayConferencePlat ? <p name={'errordisplayConferencePlat'}
                                  style={{
                                    color: 'red'
                                  }}>
                                  You must fill this field to submit this form

                                </p> : null}
                                <div>
                                  {displayConferencePlat}
                                </div>
                                <span style={{ color: '#026BC8' }}> If others, please specify</span>  <span style={{ color: 'red' }}> {selectedConferencePlat.includes('Other') ? '*' : ''} </span>
                                <InputRow
                                  name="text"
                                  rowName=""
                                  value={otherConference}
                                  required={selectedConferencePlat.includes('Other') ? '' : ''}
                                  //errMsg={validationError.selectedSecondLevel ? validationError.selectedSecondLevel : ''}
                                  disabled={selectedConferencePlat.includes('Other') ? false : true} //16 is the Id of "Other" value
                                  onChange={(e) => {
                                    this.setState({ otherConference: e })
                                  }}
                                />
                                <br />
                                <span className={'formQuestion'} >6.  What other social media platform is your instructor using? (you can choose more than one) </span><span style={{ color: 'red' }}> *</span>
                                {errordisplaysocialMedia ? <p name={'errordisplaysocialMedia'}
                                  style={{
                                    color: 'red'
                                  }}>
                                  You must fill this field to submit this form

                                </p> : null}
                                <div>
                                  {displaysocialMedia}
                                </div>
                                <span style={{ color: '#026BC8' }}> If others, please specify</span>  <span style={{ color: 'red' }}> {selectedsocialMedia.includes('Other') ? '*' : ''} </span>
                                <InputRow
                                  name="text"
                                  rowName=""
                                  value={otherSocialMedia}
                                  required={selectedsocialMedia.includes('Other') ? '' : ''}
                                  //errMsg={validationError.selectedSecondLevel ? validationError.selectedSecondLevel : ''}
                                  disabled={selectedsocialMedia.includes('Other') ? false : true} //16 is the Id of "Other" value
                                  onChange={(e) => {
                                    this.setState({ otherSocialMedia: e })
                                  }}
                                />
                                <br />
                                <span className={'formQuestion'} >7. Your expected grade in this course:(Choose one)</span><span style={{ color: 'red' }}> *</span>
                                {errordisplayExpectedGrade ? <p name={'errordisplayExpectedGrade'}
                                  style={{
                                    color: 'red'
                                  }}>
                                  You must fill this field to submit this form

                                </p> : null}
                                <InputRow
                                  name="select"
                                  data={grades}
                                  required='*'
                                  onChange={(e) => this.setState({ selectedExpectedGrade: e })}

                                  rowName="Expected Grade"
                                />
                                <br />
                                <span className={'formQuestion'} >8.  Your overall GPA at AUT: (Please Choose One)</span><span style={{ color: 'red' }}> *</span>
                                {errordisplayGPA ? <p name={'errordisplayGPA'}
                                  style={{
                                    color: 'red'
                                  }}>
                                  You must fill this field to submit this form

                                </p> : null}
                                <div>
                                  {displayGPA}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          {displayOtherQuestionsWithAccordian}
                        </div>
                        <br />


                        <button className="save" onClick={this.handleSubmit} disabled={processing}>
                          {processing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }} /> : 'Submit Form'}
                        </button>

                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>}
      </div>
    )
  }
}
FormPage.propTypes = {
  history: PropTypes.object
}
